import React, { Component, ReactNode } from 'react'
import dateUtil from '../utils/date.util'
import Logo from './Logo'

interface PageProps {
  size: 'half' | 'full'
  wrapperClass?: string
  children: ReactNode
}

export default class Page extends Component<PageProps> {
  get wrapperClass () {
    const base = 'flex flex-col items-center'
    return `${base} ${this.props.wrapperClass}`
  }

  get sizeClass () {
    const { size } = this.props
    const sizeClass = size === 'half'
      ? 'w-11/12 sm:w-2/4 md:w-2/5 lg:w-1/3 xl:w-1/4.5 mx-auto'
      : 'w-11/12 md:w-2/3 lg:w-2/3 xl:w-1/2 mx-auto'
    return sizeClass
  }

  get copyright () {
    return <span>&copy; {dateUtil.currentYear()}</span>
  }

  render () {
    return (
      <div className="bg-tertiary min-h-screen min-w-screen">
        <div className="container mx-auto">
          <div className={this.sizeClass}>
            <div className={this.wrapperClass}>
              {this.props.children}
            </div>
          </div>
          <div className="flex justify-center items-end text-secondary pb-5 mt-24 sm:mt-28">
            <Logo type="full" />
            <p className="ml-1 -mb-1">{this.copyright}</p>
          </div>
        </div>
      </div>
    )
  }
}
